
// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart, selectedBrands = [], filterByBrands }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});

//   const itemsPerPage = 4;
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // ✅ Fetch all data
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Filter products when selectedBrands changes
//   useEffect(() => {
//     console.log("Filtering Popular Items...");
//     console.log("Selected brands:", selectedBrands);
//     console.log("All products:", getProduct);
    
//     if (getProduct.length > 0) {
//       let filtered;
//       if (filterByBrands) {
//         filtered = filterByBrands(getProduct);
//       } else {
//         // Fallback filtering if filterByBrands is not provided
//         if (selectedBrands.length === 0) {
//           filtered = getProduct;
//         } else {
//           filtered = getProduct.filter(product => {
//             console.log(`Product: ${product.title}, Brand: ${product.brand_name}`);
//             return product.brand_name && selectedBrands.includes(product.brand_name);
//           });
//         }
//       }
      
//       console.log("Filtered products:", filtered);
//       setFilteredProducts(filtered);
//       // Reset current slide when products change
//       setCurrentSlide(0);
//     }
//   }, [getProduct, selectedBrands, filterByBrands]);

//   const fetchData = async () => {
//     try {
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       // Fetch most popular products
//       const popularRes = await fetch('https://backend.frozenwala.com/api/most-popular/');
//       const popularData = await popularRes.json();
      
//       console.log("Popular items:", popularData);
//       // Check if products have brand_name field
//       if (popularData.length > 0) {
//         console.log("Sample product fields:", Object.keys(popularData[0]));
//         console.log("Sample product brand_name:", popularData[0].brand_name);
//       }
      
//       setGetProduct(popularData);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       // Only fetch cart if user is logged in
//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     }
//   };

//   // ✅ Auto slide carousel
//   useEffect(() => {
//     if (filteredProducts.length > 0) {
//       const interval = setInterval(() => handleScroll("next"), 3500);
//       return () => clearInterval(interval);
//     }
//   }, [filteredProducts]);

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   // ✅ Add to cart logic
//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   // ✅ Increase/Decrease quantity
//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId];

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   // Show message when no products match the selected brands
//   if (filteredProducts.length === 0 && getProduct.length > 0) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             style={{ textAlign: "left" }}
//           >
//             Popular Items
//           </motion.h5>
//           <div className="text-center py-5">
//             <p>No popular items match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4 overflow-hidden">
//       <div className="container text-center">
//         <motion.h5
//           className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           style={{textAlign: "left"}}
//         >
//           Popular Items
//         </motion.h5>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading popular items...</p>
//           </div>
//         ) : (
//           <div className="position-relative">
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={currentSlide}
//                 className="row gx-4"
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -100 }}
//                 transition={{ duration: 0.6 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   // const isSoldOut = stock[item.id] === 0;
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <motion.div
//                       key={item.id}
//                       className="col-6 col-sm-6 col-md-4 col-lg-3"
//                     >
//                       <div className="card card-span border-0 h-70 p-0 rounded-4 position-relative small-card">
//                         {/* Sold out badge */}
//                         {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

//                         {/* ❤️ Wishlist Icon */}
//                         <div
//                           onClick={() => !wishlistLoading && toggleWishlist(item)}
//                           style={{
//                             position: "absolute",
//                             top: "15px",
//                             right: "15px",
//                             cursor: "pointer",
//                           }}
//                         >
//                           {isInWishlist ? (
//                             <FaHeart size={26} color="red" />
//                           ) : (
//                             <CiHeart size={26} color="#bbb" />
//                           )}
//                         </div>

//                         <motion.img
//                           src={item.item_photo || logo}
//                           alt={item.title}
//                           className="img-fluid rounded-4 w-100 popular-img"
//                           style={{cursor:"pointer"}}
//                           transition={{ duration: 0.4 }}
//                           onClick={()=>navigate(`products/${item.id}`)}
//                         />

//                         <div className="card-body px-0 text-center">                         
//                           <h6
//                             className="fw-bold text-truncate"
//                             style={{ textAlign: "left" }}
//                           >
//                             {item.title}
//                           </h6>
//                           <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
//                             <p
//                               className="old-price"
//                               style={{
//                                 textDecoration: `${item.item_old_price === item.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{item.item_old_price || 0}
//                             </p>
//                             <p className="fw-bold" style={{fontSize: "0.83333rem"}}>
//                               ₹{item.item_new_price}
//                             </p>
//                             <p className="discount-badge" style={{ 
//                               color: 'green', 
//                               fontSize: '0.83333rem', 
//                             }}>
//                               {item.discount_percentage}% OFF
//                             </p>
//                           </div>
//                           {cartQty && !isSoldOut && isLoggedIn ? (
//                             <div className="d-flex justify-content-center align-items-center gap-2">
//                               <button className="qty-btn" onClick={() => subOne(item.id)}>
//                                 -
//                               </button>
//                               <span className="fw-bold">{cartQty}</span>
//                               <button className="qty-btn" onClick={() => addOne(item.id)}>
//                                 +
//                               </button>
//                             </div>
//                           ) : (
//                             <button
//                               className="btn btn-danger btn-sm rounded-pill"
//                               onClick={() => onPressAddToCart(item.id)}
//                               disabled={isSoldOut}
//                               style={{padding: "6px 12px", fontSize: "12px"}}
//                             >
//                               Add to Cart
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     </motion.div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const uid = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       let url = "https://backend.frozenwala.com/api/most-popular/";
//       if (selectedBrands && selectedBrands.length > 0) {
//         url += `?brand=${encodeURIComponent(selectedBrands.join(','))}`;
//       }
//       const res = await fetch(url);
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         setProducts(data);
//       }
//     } catch (err) {
//       console.error("Error loading recommendations:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleQuickAdd = async (e, productId) => {
//     e.stopPropagation();
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       refreshCart();
//     } catch (err) {
//       console.error("Quick add failed", err);
//     }
//   };

//   return (
//     <div
//       className="card h-100 border-0 p-4 p-sm-4 p-3 recommended-main-card"
//       style={{
//         borderRadius: "28px",
//         backgroundColor: "#ffffff",
//         boxShadow: "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)",
//         border: "1px solid rgba(0,0,0,0.04)",
//         transition: "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s cubic-bezier(0.2, 0.8, 0.2, 1)",
//         width: "100%",
//         maxWidth: "100%"
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow =
//           "0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow =
//           "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)";
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h4 className="fw-bold m-0 text-dark" style={{ fontSize: "20px", letterSpacing: "-0.3px" }}>
//           Popular Products
//         </h4>
//         <button
//           onClick={() => navigate("/search")}
//           className="btn btn-link p-0 fw-semibold text-decoration-none"
//           style={{ color: "#5dc5fa", fontSize: "14px" }}
//         >
//           View All
//         </button>
//       </div>

//       {/* Scrollable list container – vertical scroll only, no horizontal overflow */}
//       <div
//         className="flex-grow-1"
//         style={{
//           maxHeight: "420px",
//           overflowY: "auto",
//           overflowX: "hidden",   // prevent any accidental horizontal scrollbar
//           paddingRight: "4px",
//           width: "100%"
//         }}
//       >
//         {loading ? (
//           /* Premium skeleton placeholders */
//           [...Array(4)].map((_, i) => (
//             <div key={i} className="d-flex align-items-center p-3 mb-1 rounded-3 skeleton-row" style={{ width: "100%" }}>
//               <div
//                 className="skeleton-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   borderRadius: "16px",
//                   flexShrink: 0,
//                   marginRight: "12px"
//                 }}
//               />
//               <div className="flex-grow-1" style={{ minWidth: 0 }}>
//                 <div className="skeleton-line skeleton-title-line" />
//                 <div className="skeleton-line skeleton-subtitle-line" style={{ marginTop: "8px" }} />
//                 <div className="d-flex gap-2 mt-2">
//                   <div className="skeleton-badge" style={{ width: "48px", height: "18px", borderRadius: "20px" }} />
//                   <div className="skeleton-line" style={{ width: "40px", height: "12px", borderRadius: "4px" }} />
//                 </div>
//               </div>
//               <div className="text-end ms-2 flex-shrink-0">
//                 <div className="skeleton-line" style={{ width: "50px", height: "14px", borderRadius: "4px" }} />
//                 <div className="skeleton-line mt-1" style={{ width: "36px", height: "18px", borderRadius: "4px" }} />
//               </div>
//               <div
//                 className="skeleton-circle"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   borderRadius: "50%",
//                   marginLeft: "12px",
//                   flexShrink: 0
//                 }}
//               />
//             </div>
//           ))
//         ) : products.length === 0 ? (
//           <p className="text-muted small text-center my-auto">
//             No recommended products matched filtering parameters.
//           </p>
//         ) : (
//           products.map((item) => (
//             <div
//               key={item.id}
//               className="d-flex align-items-center justify-content-between p-3 rounded-3 recommended-row"
//               style={{
//                 transition: "all 0.2s ease",
//                 cursor: "pointer",
//                 marginBottom: "6px",
//                 width: "100%",
//                 minWidth: 0
//               }}
//               onClick={() => navigate(`products/${item.id}`)}
//             >
//               {/* Image – fixed size, won't shrink */}
//               <img
//                 src={item.item_photo || logo}
//                 alt={item.title}
//                 className="recommended-item-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   objectFit: "cover",
//                   borderRadius: "16px",
//                   backgroundColor: "#f8f9fa",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
//                   flexShrink: 0
//                 }}
//               />

//               {/* Middle content – allowed to shrink & truncate */}
//               <div
//                 className="d-flex flex-column justify-content-center"
//                 style={{
//                   marginLeft: "12px",
//                   flexGrow: 1,
//                   minWidth: 0,          // crucial for text truncation
//                   overflow: "hidden"
//                 }}
//               >
//                 <h6
//                   className="fw-bold mb-1 text-dark text-truncate"
//                   style={{
//                     fontSize: "14px",
//                     letterSpacing: "-0.2px",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis"
//                   }}
//                 >
//                   {item.title}
//                 </h6>
//                 {/* <p className="text-muted mb-1 small" style={{ fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//                   {item.brand || "Spice Hub"}
//                 </p> */}
//                 <div className="d-flex align-items-center gap-2">
//                   {item.discount_percentage && (
//                     <span
//                       className="fw-bold"
//                       style={{
//                         color: "#28a745",
//                         fontSize: "11px",
//                         background: "#eaf7ea",
//                         padding: "2px 8px",
//                         borderRadius: "20px",
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       {item.discount_percentage}% OFF
//                     </span>
//                   )}
//                   <span style={{ color: "#5dc5fa", fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>
//                     ★ {item.rating || "4.6"}
//                   </span>
//                 </div>
//               </div>

//               {/* Price and button block – stays on the right, won't shrink */}
//               <div
//                 className="d-flex align-items-center gap-3 ms-2"
//                 style={{ flexShrink: 0 }}
//               >
//                 <div className="text-end" style={{ whiteSpace: "nowrap" }}>
//                   {item.item_old_price && (
//                     <span
//                       className="text-muted text-decoration-line-through d-block"
//                       style={{ fontSize: "12px", lineHeight: "1" }}
//                     >
//                       ₹{item.item_old_price}
//                     </span>
//                   )}
//                   <span
//                     className="fw-bold text-dark"
//                     style={{ fontSize: "16px", lineHeight: "1" }}
//                   >
//                     ₹{item.item_new_price}
//                   </span>
//                 </div>
//                 <button
//                   onClick={(e) => handleQuickAdd(e, item.id)}
//                   className="btn d-flex align-items-center justify-content-center text-white p-0"
//                   style={{
//                     width: "32px",
//                     height: "32px",
//                     backgroundColor: "#5dc5fa",
//                     borderRadius: "50%",
//                     border: "none",
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     boxShadow: "0 4px 10px rgba(241,114,40,0.3)",
//                     transition: "transform 0.15s",
//                     flexShrink: 0
//                   }}
//                   onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
//                   onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//                   disabled={item.stock === 0}
//                 >
//                   +
//                 </button>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       <style>{`
//         .recommended-row:hover {
//           background-color: #f9fafb;
//           box-shadow: 0 4px 16px rgba(0,0,0,0.06);
//         }
//         /* Custom scrollbar – vertical only */
//         .flex-grow-1::-webkit-scrollbar {
//           width: 4px;
//         }
//         .flex-grow-1::-webkit-scrollbar-thumb {
//           background: #e0e0e0;
//           border-radius: 10px;
//         }

//         /* Premium skeleton design */
//         .skeleton-row {
//           background: #ffffff;
//           width: 100%;
//         }
//         .skeleton-img,
//         .skeleton-line,
//         .skeleton-badge,
//         .skeleton-circle {
//           background: linear-gradient(
//             90deg,
//             #f5f5f5 0%,
//             #eaeaea 40%,
//             #f5f5f5 80%
//           );
//           background-size: 200% 100%;
//           animation: shimmer 1.8s infinite ease-in-out;
//         }
//         .skeleton-title-line {
//           height: 14px;
//           width: 80%;
//           border-radius: 6px;
//         }
//         .skeleton-subtitle-line {
//           height: 12px;
//           width: 50%;
//           border-radius: 6px;
//         }

//         @keyframes shimmer {
//           0% {
//             background-position: -200% 0;
//           }
//           100% {
//             background-position: 200% 0;
//           }
//         }

//         /* Hover pop for main card */
//         .recommended-main-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9);
//         }

//         /* Mobile adjustments – smaller padding, no horizontal scroll */
//         @media (max-width: 575.98px) {
//           .recommended-main-card {
//             padding: 16px !important;  /* reduce from p-4/p-3 */
//           }
//           .recommended-item-img {
//             width: 60px !important;
//             height: 60px !important;
//             border-radius: 12px !important;
//           }
//           .recommended-row {
//             padding: 10px 8px !important;
//           }
//           /* ensure no horizontal overflow */
//           .recommended-main-card,
//           .flex-grow-1 {
//             max-width: 100%;
//             overflow-x: hidden;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Popular;

// Popular.jsx - Updated with View All button

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";
// import { FaArrowRight } from "react-icons/fa";

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const uid = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       let url = "https://backend.frozenwala.com/api/most-popular/";
//       if (selectedBrands && selectedBrands.length > 0) {
//         url += `?brand=${encodeURIComponent(selectedBrands.join(','))}`;
//       }
//       const res = await fetch(url);
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         setProducts(data);
//       }
//     } catch (err) {
//       console.error("Error loading recommendations:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleQuickAdd = async (e, productId) => {
//     e.stopPropagation();
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       refreshCart();
//     } catch (err) {
//       console.error("Quick add failed", err);
//     }
//   };

//   const handleViewAll = () => {
//     navigate('/popular-products', { 
//       state: { 
//         products: products,
//         selectedBrands: selectedBrands
//       } 
//     });
//   };

//   return (
//     <div
//       className="card h-100 border-0 p-4 p-sm-4 p-3 recommended-main-card"
//       style={{
//         borderRadius: "28px",
//         backgroundColor: "#ffffff",
//         boxShadow: "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)",
//         border: "1px solid rgba(0,0,0,0.04)",
//         transition: "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s cubic-bezier(0.2, 0.8, 0.2, 1)",
//         width: "100%",
//         maxWidth: "100%"
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow =
//           "0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow =
//           "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)";
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h4 className="fw-bold m-0 text-dark" style={{ fontSize: "20px", letterSpacing: "-0.3px" }}>
//           Popular Products
//         </h4>
//         <button
//           onClick={handleViewAll}
//           className="view-all-popular-btn"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             background: "transparent",
//             border: "2px solid #5dc5fa",
//             borderRadius: "50px",
//             padding: "5px 16px",
//             fontSize: "13px",
//             fontWeight: 700,
//             color: "#5dc5fa",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             whiteSpace: "nowrap",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.background = "#5dc5fa";
//             e.currentTarget.style.color = "#fff";
//             e.currentTarget.style.transform = "translateX(4px)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.background = "transparent";
//             e.currentTarget.style.color = "#5dc5fa";
//             e.currentTarget.style.transform = "translateX(0)";
//           }}
//         >
//           View All <FaArrowRight size={12} />
//         </button>
//       </div>

//       {/* Scrollable list container – vertical scroll only, no horizontal overflow */}
//       <div
//         className="flex-grow-1"
//         style={{
//           maxHeight: "420px",
//           overflowY: "auto",
//           overflowX: "hidden",
//           paddingRight: "4px",
//           width: "100%"
//         }}
//       >
//         {loading ? (
//           /* Premium skeleton placeholders */
//           [...Array(4)].map((_, i) => (
//             <div key={i} className="d-flex align-items-center p-3 mb-1 rounded-3 skeleton-row" style={{ width: "100%" }}>
//               <div
//                 className="skeleton-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   borderRadius: "16px",
//                   flexShrink: 0,
//                   marginRight: "12px"
//                 }}
//               />
//               <div className="flex-grow-1" style={{ minWidth: 0 }}>
//                 <div className="skeleton-line skeleton-title-line" />
//                 <div className="skeleton-line skeleton-subtitle-line" style={{ marginTop: "8px" }} />
//                 <div className="d-flex gap-2 mt-2">
//                   <div className="skeleton-badge" style={{ width: "48px", height: "18px", borderRadius: "20px" }} />
//                   <div className="skeleton-line" style={{ width: "40px", height: "12px", borderRadius: "4px" }} />
//                 </div>
//               </div>
//               <div className="text-end ms-2 flex-shrink-0">
//                 <div className="skeleton-line" style={{ width: "50px", height: "14px", borderRadius: "4px" }} />
//                 <div className="skeleton-line mt-1" style={{ width: "36px", height: "18px", borderRadius: "4px" }} />
//               </div>
//               <div
//                 className="skeleton-circle"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   borderRadius: "50%",
//                   marginLeft: "12px",
//                   flexShrink: 0
//                 }}
//               />
//             </div>
//           ))
//         ) : products.length === 0 ? (
//           <p className="text-muted small text-center my-auto">
//             No popular products found.
//           </p>
//         ) : (
//           products.map((item) => (
//             <div
//               key={item.id}
//               className="d-flex align-items-center justify-content-between p-3 rounded-3 recommended-row"
//               style={{
//                 transition: "all 0.2s ease",
//                 cursor: "pointer",
//                 marginBottom: "6px",
//                 width: "100%",
//                 minWidth: 0
//               }}
//               onClick={() => navigate(`products/${item.id}`)}
//             >
//               {/* Image – fixed size, won't shrink */}
//               <img
//                 src={item.item_photo || logo}
//                 alt={item.title}
//                 className="recommended-item-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   objectFit: "cover",
//                   borderRadius: "16px",
//                   backgroundColor: "#f8f9fa",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
//                   flexShrink: 0
//                 }}
//               />

//               {/* Middle content – allowed to shrink & truncate */}
//               <div
//                 className="d-flex flex-column justify-content-center"
//                 style={{
//                   marginLeft: "12px",
//                   flexGrow: 1,
//                   minWidth: 0,
//                   overflow: "hidden"
//                 }}
//               >
//                 <h6
//                   className="fw-bold mb-1 text-dark text-truncate"
//                   style={{
//                     fontSize: "14px",
//                     letterSpacing: "-0.2px",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis"
//                   }}
//                 >
//                   {item.title}
//                 </h6>
//                 <div className="d-flex align-items-center gap-2">
//                   {item.discount_percentage && (
//                     <span
//                       className="fw-bold"
//                       style={{
//                         color: "#28a745",
//                         fontSize: "11px",
//                         background: "#eaf7ea",
//                         padding: "2px 8px",
//                         borderRadius: "20px",
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       {item.discount_percentage}% OFF
//                     </span>
//                   )}
//                   <span style={{ color: "#5dc5fa", fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>
//                     ★ {item.rating || "4.6"}
//                   </span>
//                 </div>
//               </div>
 
//               {/* Price and button block – stays on the right, won't shrink */}
//               <div
//                 className="d-flex align-items-center gap-3 ms-2"
//                 style={{ flexShrink: 0 }}
//               >
//                 <div className="text-end" style={{ whiteSpace: "nowrap" }}>
//                   {item.item_old_price && (
//                     <span
//                       className="text-muted text-decoration-line-through d-block"
//                       style={{ fontSize: "12px", lineHeight: "1" }}
//                     >
//                       ₹{item.item_old_price}
//                     </span>
//                   )}
//                   <span
//                     className="fw-bold text-dark"
//                     style={{ fontSize: "16px", lineHeight: "1" }}
//                   >
//                     ₹{item.item_new_price}
//                   </span>
//                 </div>
//                 <button
//                   onClick={(e) => handleQuickAdd(e, item.id)}
//                   className="btn d-flex align-items-center justify-content-center text-white p-0"
//                   style={{
//                     width: "32px",
//                     height: "32px",
//                     backgroundColor: "#5dc5fa",
//                     borderRadius: "50%",
//                     border: "none",
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     boxShadow: "0 4px 10px rgba(241,114,40,0.3)",
//                     transition: "transform 0.15s",
//                     flexShrink: 0
//                   }}
//                   onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
//                   onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//                   disabled={item.stock === 0}
//                 >
//                   +
//                 </button>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       <style>{`
//         .recommended-row:hover {
//           background-color: #f9fafb;
//           box-shadow: 0 4px 16px rgba(0,0,0,0.06);
//         }
//         /* Custom scrollbar – vertical only */
//         .flex-grow-1::-webkit-scrollbar {
//           width: 4px;
//         }
//         .flex-grow-1::-webkit-scrollbar-thumb {
//           background: #e0e0e0;
//           border-radius: 10px;
//         }

//         /* Premium skeleton design */
//         .skeleton-row {
//           background: #ffffff;
//           width: 100%;
//         }
//         .skeleton-img,
//         .skeleton-line,
//         .skeleton-badge,
//         .skeleton-circle {
//           background: linear-gradient(
//             90deg,
//             #f5f5f5 0%,
//             #eaeaea 40%,
//             #f5f5f5 80%
//           );
//           background-size: 200% 100%;
//           animation: shimmer 1.8s infinite ease-in-out;
//         }
//         .skeleton-title-line {
//           height: 14px;
//           width: 80%;
//           border-radius: 6px;
//         }
//         .skeleton-subtitle-line {
//           height: 12px;
//           width: 50%;
//           border-radius: 6px;
//         }

//         @keyframes shimmer {
//           0% {
//             background-position: -200% 0;
//           }
//           100% {
//             background-position: 200% 0;
//           }
//         }

//         /* Hover pop for main card */
//         .recommended-main-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9);
//         }

//         /* Mobile adjustments – smaller padding, no horizontal scroll */
//         @media (max-width: 575.98px) {
//           .recommended-main-card {
//             padding: 16px !important;
//           }
//           .recommended-item-img {
//             width: 60px !important;
//             height: 60px !important;
//             border-radius: 12px !important;
//           }
//           .recommended-row {
//             padding: 10px 8px !important;
//           }
//           .recommended-main-card,
//           .flex-grow-1 {
//             max-width: 100%;
//             overflow-x: hidden;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Popular;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";
// import { FaArrowRight } from "react-icons/fa";
// import ProductModal from "./ProductModal"; // Add this import

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Modal states - Add these
//   const [selectedProductId, setSelectedProductId] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
  
//   const navigate = useNavigate();
//   const uid = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       let url = "https://backend.frozenwala.com/api/most-popular/";
//       if (selectedBrands && selectedBrands.length > 0) {
//         url += `?brand=${encodeURIComponent(selectedBrands.join(','))}`;
//       }
//       const res = await fetch(url);
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         setProducts(data);
//       }
//     } catch (err) {
//       console.error("Error loading recommendations:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Add this handler for opening modal
//   const handleProductClick = (productId) => {
//     setSelectedProductId(productId);
//     setIsModalOpen(true);
//   };

//   // Add this handler for closing modal
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedProductId(null);
//   };

//   const handleQuickAdd = async (e, productId) => {
//     e.stopPropagation();
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       refreshCart();
//     } catch (err) {
//       console.error("Quick add failed", err);
//     }
//   };

//   const handleViewAll = () => {
//     navigate('/popular-products', { 
//       state: { 
//         products: products,
//         selectedBrands: selectedBrands
//       } 
//     });
//   };

//   return (
//     <div
//       className="card h-100 border-0 p-4 p-sm-4 p-3 recommended-main-card"
//       style={{
//         borderRadius: "28px",
//         backgroundColor: "#ffffff",
//         boxShadow: "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)",
//         border: "1px solid rgba(0,0,0,0.04)",
//         transition: "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s cubic-bezier(0.2, 0.8, 0.2, 1)",
//         width: "100%",
//         maxWidth: "100%"
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow =
//           "0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow =
//           "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)";
//       }}
//     >
//       {/* Add the ProductModal here */}
//       <ProductModal
//         isOpen={isModalOpen}
//         productId={selectedProductId}
//         onClose={handleCloseModal}
//         refreshCart={refreshCart}
//       />

//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h4 className="fw-bold m-0 text-dark" style={{ fontSize: "20px", le5tterSpacing: "-0.3px" }}>
//           Popular Products
//         </h4>
//         <button
//           onClick={handleViewAll}
//           className="view-all-popular-btn"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             background: "transparent",
//             border: "2px solid #5dc5fa",
//             borderRadius: "50px",
//             padding: "5px 16px",
//             fontSize: "13px",
//             fontWeight: 700,
//             color: "#5dc5fa",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             whiteSpace: "nowrap",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.background = "#5dc5fa";
//             e.currentTarget.style.color = "#fff";
//             e.currentTarget.style.transform = "translateX(4px)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.background = "transparent";
//             e.currentTarget.style.color = "#5dc5fa";
//             e.currentTarget.style.transform = "translateX(0)";
//           }}
//         >
//           View All <FaArrowRight size={12} />
//         </button>
//       </div>

//       {/* Scrollable list container – vertical scroll only, no horizontal overflow */}
//       <div
//         className="flex-grow-1"
//         style={{
//           maxHeight: "420px",
//           overflowY: "auto",
//           overflowX: "hidden",
//           paddingRight: "4px",
//           width: "100%"
//         }}
//       >
//         {loading ? (
//           /* Premium skeleton placeholders */
//           [...Array(4)].map((_, i) => (
//             <div key={i} className="d-flex align-items-center p-3 mb-1 rounded-3 skeleton-row" style={{ width: "100%" }}>
//               <div
//                 className="skeleton-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   borderRadius: "16px",
//                   flexShrink: 0,
//                   marginRight: "12px"
//                 }}
//               />
//               <div className="flex-grow-1" style={{ minWidth: 0 }}>
//                 <div className="skeleton-line skeleton-title-line" />
//                 <div className="skeleton-line skeleton-subtitle-line" style={{ marginTop: "8px" }} />
//                 <div className="d-flex gap-2 mt-2">
//                   <div className="skeleton-badge" style={{ width: "48px", height: "18px", borderRadius: "20px" }} />
//                   <div className="skeleton-line" style={{ width: "40px", height: "12px", borderRadius: "4px" }} />
//                 </div>
//               </div>
//               <div className="text-end ms-2 flex-shrink-0">
//                 <div className="skeleton-line" style={{ width: "50px", height: "14px", borderRadius: "4px" }} />
//                 <div className="skeleton-line mt-1" style={{ width: "36px", height: "18px", borderRadius: "4px" }} />
//               </div>
//               <div
//                 className="skeleton-circle"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   borderRadius: "50%",
//                   marginLeft: "12px",
//                   flexShrink: 0
//                 }}
//               />
//             </div>
//           ))
//         ) : products.length === 0 ? (
//           <p className="text-muted small text-center my-auto">
//             No popular products found.
//           </p>
//         ) : (
//           products.map((item) => (
//             <div
//               key={item.id}
//               className="d-flex align-items-center justify-content-between p-3 rounded-3 recommended-row"
//               style={{
//                 transition: "all 0.2s ease",
//                 cursor: "pointer",
//                 marginBottom: "6px",
//                 width: "100%",
//                 minWidth: 0
//               }}
//               // Replace navigation with modal handler
//               onClick={() => handleProductClick(item.id)}
//             >
//               {/* Image – fixed size, won't shrink */}
//               <img
//                 src={item.item_photo || logo}
//                 alt={item.title}
//                 className="recommended-item-img"
//                 style={{
//                   width: "72px",
//                   height: "72px",
//                   objectFit: "cover",
//                   borderRadius: "16px",
//                   backgroundColor: "#f8f9fa",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
//                   flexShrink: 0,
//                   cursor: "pointer"
//                 }}
//                 // Add click handler to image too
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleProductClick(item.id);
//                 }}
//               />

//               {/* Middle content – allowed to shrink & truncate */}
//               <div
//                 className="d-flex flex-column justify-content-center"
//                 style={{
//                   marginLeft: "12px",
//                   flexGrow: 1,
//                   minWidth: 0,
//                   overflow: "hidden",
//                   cursor: "pointer"
//                 }}
//                 // Add click handler to the content div
//                 onClick={() => handleProductClick(item.id)}
//               >
//                 <h6
//                   className="fw-bold mb-1 text-dark text-truncate"
//                   style={{
//                     fontSize: "14px",
//                     letterSpacing: "-0.2px",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis"
//                   }}
//                 >
//                   {item.title}
//                 </h6>
//                 <div className="d-flex align-items-center gap-2">
//                   {item.discount_percentage && (
//                     <span
//                       className="fw-bold"
//                       style={{
//                         color: "#28a745",
//                         fontSize: "11px",
//                         background: "#eaf7ea",
//                         padding: "2px 8px",
//                         borderRadius: "20px",
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       {item.discount_percentage}% OFF
//                     </span>
//                   )}
//                   <span style={{ color: "#5dc5fa", fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>
//                     ★ {item.rating || "4.6"}
//                   </span>
//                 </div>
//               </div>
 
//               {/* Price and button block – stays on the right, won't shrink */}
//               <div
//                 className="d-flex align-items-center gap-3 ms-2"
//                 style={{ flexShrink: 0 }}
//               >
//                 <div className="text-end" style={{ whiteSpace: "nowrap" }}>
//                   {item.item_old_price && (
//                     <span
//                       className="text-muted text-decoration-line-through d-block"
//                       style={{ fontSize: "12px", lineHeight: "1" }}
//                     >
//                       ₹{item.item_old_price}
//                     </span>
//                   )}
//                   <span
//                     className="fw-bold text-dark"
//                     style={{ fontSize: "16px", lineHeight: "1" }}
//                   >
//                     ₹{item.item_new_price}
//                   </span>
//                 </div>
//                 <button
//                   onClick={(e) => handleQuickAdd(e, item.id)}
//                   className="btn d-flex align-items-center justify-content-center text-white p-0"
//                   style={{
//                     width: "32px",
//                     height: "32px",
//                     backgroundColor: "#5dc5fa",
//                     borderRadius: "50%",
//                     border: "none",
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     boxShadow: "0 4px 10px rgba(241,114,40,0.3)",
//                     transition: "transform 0.15s",
//                     flexShrink: 0
//                   }}
//                   onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
//                   onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//                   disabled={item.stock === 0}
//                 >
//                   +
//                 </button>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       <style>{`
//         .recommended-row:hover {
//           background-color: #f9fafb;
//           box-shadow: 0 4px 16px rgba(0,0,0,0.06);
//         }
//         /* Custom scrollbar – vertical only */
//         .flex-grow-1::-webkit-scrollbar {
//           width: 4px;
//         }
//         .flex-grow-1::-webkit-scrollbar-thumb {
//           background: #e0e0e0;
//           border-radius: 10px;
//         }

//         /* Premium skeleton design */
//         .skeleton-row {
//           background: #ffffff;
//           width: 100%;
//         }
//         .skeleton-img,
//         .skeleton-line,
//         .skeleton-badge,
//         .skeleton-circle {
//           background: linear-gradient(
//             90deg,
//             #f5f5f5 0%,
//             #eaeaea 40%,
//             #f5f5f5 80%
//           );
//           background-size: 200% 100%;
//           animation: shimmer 1.8s infinite ease-in-out;
//         }
//         .skeleton-title-line {
//           height: 14px;
//           width: 80%;
//           border-radius: 6px;
//         }
//         .skeleton-subtitle-line {
//           height: 12px;
//           width: 50%;
//           border-radius: 6px;
//         }

//         @keyframes shimmer {
//           0% {
//             background-position: -200% 0;
//           }
//           100% {
//             background-position: 200% 0;
//           }
//         }

//         /* Hover pop for main card */
//         .recommended-main-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9);
//         }

//         /* Mobile adjustments – smaller padding, no horizontal scroll */
//         @media (max-width: 575.98px) {
//           .recommended-main-card {
//             padding: 16px !important;
//           }
//           .recommended-item-img {
//             width: 60px !important;
//             height: 60px !important;
//             border-radius: 12px !important;
//           }
//           .recommended-row {
//             padding: 10px 8px !important;
//           }
//           .recommended-main-card,
//           .flex-grow-1 {
//             max-width: 100%;
//             overflow-x: hidden;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Popular;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../Utills/Api";
import logo from "../../Frozenwala.png";
import { FaArrowRight } from "react-icons/fa";
import ProductModal from "./ProductModal";

function Popular({ refreshCart, selectedBrands = [] }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const navigate = useNavigate();
  const uid = localStorage.getItem("user_id");

  useEffect(() => {
    fetchData();
  }, [selectedBrands]);

  const fetchData = async () => {
    try {
      setLoading(true);
      let url = "https://backend.frozenwala.com/api/most-popular/";
      if (selectedBrands && selectedBrands.length > 0) {
        url += `?brand=${encodeURIComponent(selectedBrands.join(','))}`;
      }
      const res = await fetch(url);
      const data = await res.json();
      if (Array.isArray(data)) {
        setProducts(data);
      }
    } catch (err) {
      console.error("Error loading recommendations:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleProductClick = (productId) => {
    setSelectedProductId(productId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProductId(null);
  };

  const handleQuickAdd = async (e, productId) => {
    e.stopPropagation();
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
      refreshCart();
    } catch (err) {
      console.error("Quick add failed", err);
    }
  };

  const handleViewAll = () => {
    // Only show View All if products > 4
    if (products.length > 4) {
      navigate('/popular-products', { 
        state: { 
          products: products,
          selectedBrands: selectedBrands
        } 
      });
    }
  };

  return (
    <div
      className="card h-100 border-0 p-4 p-sm-4 p-3 recommended-main-card"
      style={{
        borderRadius: "28px",
        backgroundColor: "#ffffff",
        boxShadow: "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)",
        border: "1px solid rgba(0,0,0,0.04)",
        transition: "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s cubic-bezier(0.2, 0.8, 0.2, 1)",
        width: "100%",
        maxWidth: "100%"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow =
          "0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 30px 60px -15px rgba(0, 0, 0, 0.18), 0 8px 24px -6px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255,255,255,0.8)";
      }}
    >
      {/* Full Page Product Modal */}
      <ProductModal
        isOpen={isModalOpen}
        productId={selectedProductId}
        onClose={handleCloseModal}
        refreshCart={refreshCart}
        isFullPage={true}
      />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold m-0 text-dark" style={{ fontSize: "20px", letterSpacing: "-0.3px" }}>
          Popular Products
        </h4>
        {/* Only show View All button if products > 4 */}
        {products.length > 4 && (
          <button
            onClick={handleViewAll}
            className="view-all-popular-btn"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              background: "transparent",
              border: "2px solid #5dc5fa",
              borderRadius: "50px",
              padding: "5px 16px",
              fontSize: "13px",
              fontWeight: 700,
              color: "#5dc5fa",
              cursor: "pointer",
              transition: "all 0.3s ease",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#5dc5fa";
              e.currentTarget.style.color = "#fff";
              e.currentTarget.style.transform = "translateX(4px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#5dc5fa";
              e.currentTarget.style.transform = "translateX(0)";
            }}
          >
            View All <FaArrowRight size={12} />
          </button>
        )}
      </div>

      {/* Scrollable list container */}
      <div
        className="flex-grow-1"
        style={{
          maxHeight: "420px",
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "4px",
          width: "100%"
        }}
      >
        {loading ? (
          [...Array(4)].map((_, i) => (
            <div key={i} className="d-flex align-items-center p-3 mb-1 rounded-3 skeleton-row" style={{ width: "100%" }}>
              <div
                className="skeleton-img"
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "16px",
                  flexShrink: 0,
                  marginRight: "12px"
                }}
              />
              <div className="flex-grow-1" style={{ minWidth: 0 }}>
                <div className="skeleton-line skeleton-title-line" />
                <div className="skeleton-line skeleton-subtitle-line" style={{ marginTop: "8px" }} />
                <div className="d-flex gap-2 mt-2">
                  <div className="skeleton-badge" style={{ width: "48px", height: "18px", borderRadius: "20px" }} />
                  <div className="skeleton-line" style={{ width: "40px", height: "12px", borderRadius: "4px" }} />
                </div>
              </div>
              <div className="text-end ms-2 flex-shrink-0">
                <div className="skeleton-line" style={{ width: "50px", height: "14px", borderRadius: "4px" }} />
                <div className="skeleton-line mt-1" style={{ width: "36px", height: "18px", borderRadius: "4px" }} />
              </div>
              <div
                className="skeleton-circle"
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  marginLeft: "12px",
                  flexShrink: 0
                }}
              />
            </div>
          ))
        ) : products.length === 0 ? (
          <p className="text-muted small text-center my-auto">
            No popular products found.
          </p>
        ) : (
          products.map((item) => (
            <div
              key={item.id}
              className="d-flex align-items-center justify-content-between p-3 rounded-3 recommended-row"
              style={{
                transition: "all 0.2s ease",
                cursor: "pointer",
                marginBottom: "6px",
                width: "100%",
                minWidth: 0
              }}
              onClick={() => handleProductClick(item.id)}
            >
              <img
                src={item.item_photo || logo}
                alt={item.title}
                className="recommended-item-img"
                style={{
                  width: "72px",
                  height: "72px",
                  objectFit: "cover",
                  borderRadius: "16px",
                  backgroundColor: "#f8f9fa",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                  flexShrink: 0,
                  cursor: "pointer"
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleProductClick(item.id);
                }}
              />

              <div
                className="d-flex flex-column justify-content-center"
                style={{
                  marginLeft: "12px",
                  flexGrow: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  cursor: "pointer"
                }}
                onClick={() => handleProductClick(item.id)}
              >
                <h6
                  className="fw-bold mb-1 text-dark text-truncate"
                  style={{
                    fontSize: "14px",
                    letterSpacing: "-0.2px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {item.title}
                </h6>
                <div className="d-flex align-items-center gap-2">
                  {item.discount_percentage && (
                    <span
                      className="fw-bold"
                      style={{
                        color: "#28a745",
                        fontSize: "11px",
                        background: "#eaf7ea",
                        padding: "2px 8px",
                        borderRadius: "20px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {item.discount_percentage}% OFF
                    </span>
                  )}
                  <span style={{ color: "#5dc5fa", fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>
                    ★ {item.rating || "4.6"}
                  </span>
                </div>
              </div>
 
              <div
                className="d-flex align-items-center gap-3 ms-2"
                style={{ flexShrink: 0 }}
              >
                <div className="text-end" style={{ whiteSpace: "nowrap" }}>
                  {item.item_old_price && (
                    <span
                      className="text-muted text-decoration-line-through d-block"
                      style={{ fontSize: "12px", lineHeight: "1" }}
                    >
                      ₹{item.item_old_price}
                    </span>
                  )}
                  <span
                    className="fw-bold text-dark"
                    style={{ fontSize: "16px", lineHeight: "1" }}
                  >
                    ₹{item.item_new_price}
                  </span>
                </div>
                <button
                  onClick={(e) => handleQuickAdd(e, item.id)}
                  className="btn d-flex align-items-center justify-content-center text-white p-0"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#5dc5fa",
                    borderRadius: "50%",
                    border: "none",
                    fontSize: "16px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 10px rgba(241,114,40,0.3)",
                    transition: "transform 0.15s",
                    flexShrink: 0
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
                  onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  disabled={item.stock === 0}
                >
                  +
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <style>{`
        .recommended-row:hover {
          background-color: #f9fafb;
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
        }
        .flex-grow-1::-webkit-scrollbar {
          width: 4px;
        }
        .flex-grow-1::-webkit-scrollbar-thumb {
          background: #e0e0e0;
          border-radius: 10px;
        }

        .skeleton-row {
          background: #ffffff;
          width: 100%;
        }
        .skeleton-img,
        .skeleton-line,
        .skeleton-badge,
        .skeleton-circle {
          background: linear-gradient(
            90deg,
            #f5f5f5 0%,
            #eaeaea 40%,
            #f5f5f5 80%
          );
          background-size: 200% 100%;
          animation: shimmer 1.8s infinite ease-in-out;
        }
        .skeleton-title-line {
          height: 14px;
          width: 80%;
          border-radius: 6px;
        }
        .skeleton-subtitle-line {
          height: 12px;
          width: 50%;
          border-radius: 6px;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        .recommended-main-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 35px 70px -12px rgba(0,0,0,0.22), 0 10px 30px -6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.9);
        }

        @media (max-width: 575.98px) {
          .recommended-main-card {
            padding: 16px !important;
          }
          .recommended-item-img {
            width: 60px !important;
            height: 60px !important;
            border-radius: 12px !important;
          }
          .recommended-row {
            padding: 10px 8px !important;
          }
          .recommended-main-card,
          .flex-grow-1 {
            max-width: 100%;
            overflow-x: hidden;
          }
        }
      `}</style>
    </div>
  );
}

export default Popular;